<template>
    <section v-if="items.length" class="EventsGrid">
        <div class="container container--no-pad">
            <BaseHeading
                v-if="relatedEvents || isProduct"
                :preheading="preheading"
                :heading="heading"
                tag="h2"
                class="text--black text--center mb-medium desk-mb-large h1"
            />
            <BaseHeading
                v-else
                :preheading="heading"
                tag="h2"
                class="BaseHeading--fancy"
            />
            <div class="EventsGrid__list">
                <NewsCard
                    v-for="item in visibleItems"
                    :key="item.id"
                    :item="item"
                    :tag="item.productLocations || null"
                    :is-product="isProduct"
                    :show-deals="showDeals"
                />
            </div>

            <div v-if="!relatedEvents && limitItems.length > 6" class="mt-medium text--center">
                <BaseButton
                    modifier="medium"
                    tag="button"
                    @click="expand"
                >
                    {{ limitReached ? 'View less' : 'View more' }}
                </BaseButton>
            </div>

            <div v-if="relatedEvents && relatedEventsUrl" class="mt-medium text--center">
                <BaseButton
                    modifier="medium"
                    :href="relatedEventsUrl"
                >
                    More Events
                </BaseButton>
            </div>
        </div>
    </section>
</template>

<script>
function getFacetSlug(name) {
    return name
        .toLowerCase()
        .replace('&', 'and')
        .replace(', ', '--')
        .split(' ')
        .map(encodeURIComponent)
        .join('-');
}

export default {
    props: {
        heading: {
            type: String,
            default: null
        },
        items: {
            type: Array,
            default: null
        },
        preheading: {
            type: String,
            default: null
        },
        relatedEvents: {
            type: Boolean,
            default: false
        },
        relatedCategory: {
            type: String,
            default: ''
        },
        relatedRegion: {
            type: String,
            default: ''
        },
        relatedCity: {
            type: String,
            default: ''
        },
        isProduct: {
            type: Boolean,
            default: false
        },
        limit: {
            type: Number,
            default: 100
        },
        show: {
            type: Number,
            default: 6
        },
        showDeals: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            showAll: false,
            expanded: 1
        };
    },

    computed: {
        limitReached() {
            return this.limitItems.length == this.visibleItems.length;
        },
        limitItems() {
            return this.items.slice(0, this.limit);
        },
        visibleItems() {
            if (this.relatedEvents) {
                return this.items.length < 6 ? this.items : this.items.slice(0, 6);
            } else {
                return this.limitItems.slice(0, (this.show * this.expanded));
            }
        },
        relatedEventsUrl() {
            if (this.relatedCategory && this.relatedRegion && this.relatedCity) {
                const categoryPath = getFacetSlug(this.relatedCategory);
                const regionPath = `${getFacetSlug(this.relatedRegion)}/${getFacetSlug(this.relatedCity)}/`;

                return `/events/${regionPath}?surroundings=true&category=${categoryPath}`;
            }

            return null;
        }
    },
    methods: {
        expand() {
            this.expanded = this.limitReached ?  1: this.expanded + 1;
        }
    }
}
</script>
<style lang="scss" scoped>

    .EventsGrid {
        margin-top: getSpacing('large');
        margin-bottom: getSpacing('large');

        @include media-query(desk) {
            margin-top: getSpacing('xlarge');
            margin-bottom: getSpacing('xlarge');
        }

        &::v-deep .image {
            object-fit: cover;
        }
    }

    .EventsGrid__list {
        display:-ms-grid;
        display: grid;
        -ms-grid-columns: 1fr 1fr;
        grid-template-columns: repeat(2, 1fr);
        -ms-grid-rows: 1fr;
        grid-template-rows: auto;


        @include media-query(lap-and-up) {
            -ms-grid-columns: 1fr 1fr 1fr;
            grid-template-columns: repeat(3, 1fr);
        }
    }

    .NewsCard {
        &:nth-child(1) {
            -ms-grid-column: 1;
            -ms-grid-row: 1;
        }
        &:nth-child(2) {
            -ms-grid-column: 2;
            -ms-grid-row: 1;
        }
        &:nth-child(3) {
            -ms-grid-column: 1;
            -ms-grid-row: 2;

            @include media-query(lap-and-up) {
                -ms-grid-column: 3;
                -ms-grid-row: 1;
            }
        }
        &:nth-child(4) {
            -ms-grid-column: 2;
            -ms-grid-row: 2;

            @include media-query(lap-and-up) {
                -ms-grid-column: 1;
                -ms-grid-row: 2;
            }
        }
        &:nth-child(5) {
            -ms-grid-column: 1;
            -ms-grid-row: 3;

            @include media-query(lap-and-up) {
                -ms-grid-column: 2;
                -ms-grid-row: 2;
            }
        }
        &:nth-child(6) {
            -ms-grid-column: 2;
            -ms-grid-row: 3;

            @include media-query(lap-and-up) {
                -ms-grid-column: 3;
                -ms-grid-row: 2;
            }
        }
    }
</style>
